<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("orders") }}
      </h1>
    </div>
    <div class="field">
      <generic-dropdown
        :title="$t('work order')"
        :placeholder="$t('select orders')"
        url="/work_order/catalog"
        :is_multiple="true"
        name_field="alternate_name"
        value_field="order_id"
        @selected="set_orders"
      />
    </div>

    <div class="columns">
      <div class="column is-four-fifths">
        <div class="field">
          <generic-dropdown
            :title="$t('product')"
            :placeholder="$t('select products')"
            url="/product/catalog"
            :is_multiple="true"
            name_field="name"
            value_field="product_id"
            @selected="set_products"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="is-pulled-right">
        <div class="is-primary button" @click="download_excel">
          <span class="icon"><i class="fa fa-download"></i></span>
          <span>{{ $t("download excel") }}</span>
        </div>
      </div>
      <div class="title is-5">{{ $t("orders") }}</div>
      <div class="title is-6">{{ $t("summary") }}</div>
      <div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("quantity") }}</th>
              <th>{{ $t("product") }}</th>
              <th>{{ $t("size") }}</th>
              <th>{{ $t("grade") }}</th>
              <!-- <th>{{ $t("source") }}</th> -->
              <th>{{ $t("customization") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itm, spidx) in summary_1" :key="spidx">
              <td>{{ itm.quantity }}</td>
              <!-- <td>{{ itm.element }}</td> -->
              <td>{{ itm.product_name }}</td>
              <td>{{ itm.size.toUpperCase() }}</td>
              <td>{{ itm.grade }}</td>
              <!-- <td>{{ itm.source }}</td> -->
              <td>{{ itm.customization }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="title is-6">{{ $t("detail") }}</div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("quantity") }}</th>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("source") }}</th>
            <th>{{ $t("size") }}</th>
            <th>{{ $t("grade") }}</th>
            <th>{{ $t("delivery date") }}</th>
            <th>{{ $t("customer") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(itm, spidx) in orders" :key="spidx">
            <td>{{ itm.quantity }}</td>
            <td>{{ itm.product.name }}</td>
            <td>{{ itm.order.work_order_item.order.source }}</td>
            <td>{{ itm.size }}</td>
            <td>{{ itm.order.grade }}</td>
            <td>
              {{
                format_date(
                  itm.order.work_order_item.order.settings.delivery_date
                )
              }}
            </td>
            <td>
              {{ itm.order.name }}
            </td>
          </tr>
        </tbody>
      </table> -->
      <!-- </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  post,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_date,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";
import { size } from "lodash";
import XLSX from "xlsx/dist/xlsx.full.min.js";

export default {
  name: "ProductOrderReport",
  components: { GenericTable, GenericCalendar, GenericDropdown },
  data() {
    let v = this;
    return {
      orders: [],
      meta: {
        products: [],
      },
    };
  },
  computed: {
    summary_1() {
      let v = this;
      let summary = groupBy(v.orders, (o) => {
        return `${o.product.name} ${v.$t("size")} ${o.size} ${o.order.grade}`;
      });
      console.log("summary", summary);
      let arr = Object.keys(summary)
        .map((k) => {
          return {
            element: k,
            quantity: summary[k].reduce(
              (acc, itm) => acc + Number(itm.quantity),
              0
            ),
            product_name: summary[k][0].product.name,
            size: summary[k][0].size,
            grade: summary[k][0].order.grade,
            source: summary[k][0].order.source,
            customization: summary[k].reduce((acc, itm) => {
              if (itm.customization)
                return `${acc} -${itm.customization} (${parseInt(
                  itm.quantity
                )})\n`;
              else return acc;
            }, ""),
          };
        })
        .sort((a, b) => {
          if (a.element < b.element) return -1;
          else if (a.element > b.element) return 1;
          else return 0;
        });
      return arr;
    },
  },
  methods: {
    format_date_time,
    format_date,
    format_time,
    format_currency,
    query() {
      let v = this;
      let data = {
        args: v.meta,
        report_uuid: v.$route.params.id,
        method: "qq",
      };
      post("/report/query", data)
        .then((r) => {
          v.orders = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    set_products(products) {
      let v = this;
      if (products) {
        if (Array.isArray(products))
          v.meta.products = products.map((p) => p.product_id);
        else v.meta.products = [products.product_id];
      }
    },
    set_orders(orders) {
      let v = this;
      if (orders) {
        if (Array.isArray(orders))
          v.meta.orders = orders.map((p) => p.order_id);
        else v.meta.orders = [orders.order_id];
      }
    },
    download_excel() {
      let v = this;
      let data = v.summary_1
        .map((itm) => {
          return {
            [v.$t("quantity")]: itm.quantity,
            [v.$t("product")]: itm.product_name,
            [v.$t("size")]: itm.size,
            [v.$t("grade")]: itm.grade,
            // [v.$t("source")]: itm.source,
            [v.$t("customization")]: itm.customization
              ? itm.customization.trim()
              : "",
          };
        })
        .sort((a, b) => {
          // Genera una funcion que a partir de la fecha de nacimiento, me diga la edad
          let sizeA = a.size;
          let sizeB = b.size;

          try {
            sizeA = parseInt(a.size);
            sizeB = parseInt(b.size);
          } catch {}

          if (a.product && b.product) {
            return a.product.localeCompare(b.product) || sizeA - sizeB;
          } else {
            return sizeA - sizeB;
          }
        });
      let ws = XLSX.utils.json_to_sheet(data);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "product_orders.xlsx");
    },
  },
  mounted() {},
};
</script>

<style>
/* Add Bulma styles here */
</style>
